module.exports = __webpack_public_path__ + "static/media/hotel-booking.27a91a4b.png";